import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const PlanStore = {
  namespaced: true,
  state: {
  },
  getters,
  mutations,
  actions
}

export default PlanStore
